function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.333 1.007v11.986c0 .369.299.667.667.667.368 0 .667-.298.667-.667V1.007C4.667.638 4.368.34 4 .34c-.368 0-.667.298-.667.667z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M.742 10.119c.032.48.196.94.473 1.332.287.426.7.771 1.181.985.499.214 1.032.313 1.565.294l.2-.013c.548-.017 1.12-.189 1.62-.495.455-.272.833-.665 1.09-1.135.25-.43.373-.94.348-1.453-.013-.755-.315-1.498-.846-2.064-.65-.601-1.396-1.008-2.207-1.216-.59-.155-1.136-.456-1.585-.875-.28-.294-.456-.719-.468-1.163-.015-.275.043-.527.168-.75.15-.281.361-.506.62-.664.304-.186.652-.29 1.008-.302.418-.036.803.028 1.155.183.252.112.468.293.623.523.12.17.196.356.228.55l.013.116c.025.368.344.645.711.62.367-.025.645-.344.62-.711-.033-.48-.197-.94-.474-1.332-.287-.426-.7-.771-1.181-.985-.496-.22-1.034-.323-1.573-.307l-.202.012c-.552.018-1.123.19-1.624.496-.462.282-.84.684-1.094 1.163-.242.43-.359.935-.33 1.443.02.755.328 1.495.864 2.056.58.542 1.245.93 1.967 1.155l.218.063c.602.154 1.151.453 1.604.871.272.292.445.718.453 1.163.013.277-.049.531-.177.754-.152.275-.363.495-.62.649-.265.162-.558.261-.86.294l-.153.011c-.417.037-.798-.023-1.147-.173-.246-.109-.462-.29-.617-.52-.12-.17-.196-.356-.228-.55l-.013-.116c-.025-.368-.344-.645-.711-.62-.367.025-.645.344-.62.711h.001z"
}));

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.d8b28e5e.svg";
export { ForwardRef as ReactComponent };